/**
 * Routes that never require authentication.
 *
 * Single source of truth, imported by BOTH the client-side auth gates (via
 * lib/helpers.ts `isPublicRoute`) and the Next middleware (proxy.ts). It lives in
 * its own dependency-free module on purpose: proxy.ts runs in the Edge runtime
 * and cannot pull in lib/helpers.ts, which drags along moment, JSZip, axios,
 * React and the AWS SDK. The list used to be duplicated as a literal in both
 * places with a "keep in sync" comment; this removes that hazard.
 *
 * Stored as path FRAGMENTS with no locale prefix, because the two call sites
 * receive different inputs and each matches correctly for its own:
 *
 *   * `isPublicRoute` reads `window.location.pathname`, which already carries the
 *     locale (`/en-US/sso-error/NO_ACCOUNT`), so it matches with `includes`.
 *   * proxy.ts only reaches its check after already-localised paths have returned
 *     early, so its `pathname` has no locale yet and `startsWith` is correct —
 *     and is the stricter test, which is what you want in middleware.
 */
export const PUBLIC_ROUTES = [
  "/legal",
  "/privacy-policy",
  "/sso-error",
] as const;
